import i18n from 'utils/i18n'
import type { ELabelsFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  SEARCH_USERS,
  RADIO_LIST,
  INTERVAL,
  eLabelsFiltersTitle,
  eLabelsFiltersName,
  eLabelsFiltersKey,
} from 'utils/consts'

export const getELabelsFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.countryFilter),
    filterName: eLabelsFiltersName.countryFilter,
    apiFilterName: eLabelsFiltersKey().countryFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(eLabelsFiltersTitle.updateUserUsernameFilter),
    filterName: eLabelsFiltersName.updateUserUsernameFilter,
    apiFilterName: eLabelsFiltersKey().updateUserUsernameFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(eLabelsFiltersTitle.creationDateFilter),
    filterName: eLabelsFiltersName.creationDateFilter,
    apiFilterName: eLabelsFiltersKey().creationDateFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(eLabelsFiltersTitle.lastUpdateFilter),
    filterName: eLabelsFiltersName.lastUpdateFilter,
    apiFilterName: eLabelsFiltersKey().lastUpdateFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.nationalGITypeFilter),
    filterName: eLabelsFiltersName.nationalGITypeFilter,
    apiFilterName: eLabelsFiltersKey().nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.geoIndicationFilter),
    filterName: eLabelsFiltersName.geoIndicationFilter,
    apiFilterName: eLabelsFiltersKey().geoIndicationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.specialClassificationFilter),
    filterName: eLabelsFiltersName.specialClassificationFilter,
    apiFilterName: eLabelsFiltersKey().specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.wineTypeFilter),
    filterName: eLabelsFiltersName.wineTypeFilter,
    apiFilterName: eLabelsFiltersKey().wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.wineTypeEUFilter),
    filterName: eLabelsFiltersName.wineTypeEUFilter,
    apiFilterName: eLabelsFiltersKey().wineTypeEUFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.wineColourFilter),
    filterName: eLabelsFiltersName.wineColourFilter,
    apiFilterName: eLabelsFiltersKey().wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.sweetnessTypeFilter),
    filterName: eLabelsFiltersName.sweetnessTypeFilter,
    apiFilterName: eLabelsFiltersKey().sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.vintageFilter),
    filterName: eLabelsFiltersName.vintageFilter,
    apiFilterName: eLabelsFiltersKey().vintageFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.bottleSizeFilter),
    filterName: eLabelsFiltersName.bottleSizeFilter,
    apiFilterName: eLabelsFiltersKey().bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.packageTypeFilter),
    filterName: eLabelsFiltersName.packageTypeFilter,
    apiFilterName: eLabelsFiltersKey().packageTypeFilter,
  },
  {
    type: filterTypes[INTERVAL],
    title: i18n.t(eLabelsFiltersTitle.alcoholLevelFilter),
    filterName: eLabelsFiltersName.alcoholLevelFilter,
    apiFilterName: eLabelsFiltersKey().alcoholLevelFilter,
    defaultIntervalKey: 'alcoholLevels',
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.brandFilter),
    filterName: eLabelsFiltersName.brandFilter,
    apiFilterName: eLabelsFiltersKey().brandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(eLabelsFiltersTitle.additionalInfoFilter),
    filterName: eLabelsFiltersName.additionalInfoFilter,
    apiFilterName: eLabelsFiltersKey().additionalInfoFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(eLabelsFiltersTitle.ingredientsFilledFilter),
    filterName: eLabelsFiltersName.ingredientsFilledFilter,
    apiFilterName: eLabelsFiltersKey().ingredientsFilledFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(eLabelsFiltersTitle.nutritionDeclarationFilledFilter),
    filterName: eLabelsFiltersName.nutritionDeclarationFilledFilter,
    apiFilterName: eLabelsFiltersKey().nutritionDeclarationFilledFilter,
  },
]

export const eLabelsFiltersConfig: ELabelsFiltersConfig = {
  component: 'elabels',
  getFiltersCollection: getELabelsFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
